import script from "./AtomSubTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomSubTitle.vue?vue&type=script&lang=ts&setup=true"

import "./AtomSubTitle.vue?vue&type=style&index=0&id=7ed83739&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed83739"]])

export default __exports__